// Globalne mixiny dla aplikacji Vue
export const globalMixin = {
  computed: {
    $firstDayOfWeek() {
      const locale = navigator.language || 'pl-PL';
      const country = locale.split('-')[1] || locale.split('_')[1] || locale;
      const mondayFirstCountries = [
        'pl', 'de', 'fr', 'es', 'it', 'nl', 'be', 'at', 'ch', 'se', 'no', 'dk', 'fi',
        'ru', 'cz', 'sk', 'hu', 'hr', 'si', 'ba', 'me', 'rs', 'mk', 'al', 'bg', 'ro',
        'md', 'ua', 'by', 'lt', 'lv', 'ee', 'ge', 'am', 'az', 'kz', 'kg', 'tj', 'tm', 'uz'
      ];
      return mondayFirstCountries.includes(country.toLowerCase()) ? 1 : 0;
    }
  }
};